angular.module('picmonic-common').controller('404Controller', [
  '$rootScope',
  '$scope',
  '$window',
  function ($rootScope, $scope, $window) {
    $scope.base_asset_url = $rootScope.base_asset_url;
    $scope.spinning = false;
    $scope.$emit('endInteraction');

    $scope.spin = function (event) {
      if (!$scope.spinning) {
        $scope.spinning = true;

        angular.element(event.target).toggleClass('md-spin');

        setTimeout(function () {
          angular.element(event.target).toggleClass('md-spin');
          $scope.spinning = false;
        }, 2000);
      }
    };

    $scope.showSalesforceChat = function () {
      document.getElementById('helpButtonSpan').click();
    };
  },
]);
